export const airlines = [
  {
    name: "American Airlines",
    code: "AA",
    slug: "american-airlines-aa",
    region: "United States",
    summary:
      "American Airlines is one of the world's largest airlines, operating an extensive domestic and international network from major U.S. hubs.",
  },
  {
    name: "Delta Air Lines",
    code: "DL",
    slug: "delta-air-lines-dl",
    region: "United States",
    summary:
      "Delta Air Lines is a leading global carrier serving hundreds of destinations across North America, Europe, Asia, Latin America, and Africa.",
  },
  {
    name: "Southwest Airlines",
    code: "WN",
    slug: "southwest-airlines-wn",
    region: "United States",
    summary:
      "Southwest Airlines is the largest domestic airline in the United States, known for low fares, flexible policies, and an extensive route network.",
  },
  {
    name: "JetBlue Airways",
    code: "B6",
    slug: "jetblue-airways-b6",
    region: "United States",
    summary:
      "JetBlue Airways is a major U.S. airline offering affordable service with a strong presence on East Coast, Caribbean, and transatlantic routes.",
  },
  {
    name: "Alaska Airlines",
    code: "AS",
    slug: "alaska-airlines-as",
    region: "United States",
    summary:
      "Alaska Airlines is a major U.S. carrier serving destinations across North America with hubs on the West Coast.",
  },
  {
    name: "Spirit Airlines",
    code: "NK",
    slug: "spirit-airlines-nk",
    region: "United States",
    summary:
      "Spirit Airlines is an ultra-low-cost U.S. airline operating affordable domestic and international flights.",
  },
  {
    name: "Sun Country Airlines",
    code: "SY",
    slug: "sun-country-airlines-sy",
    region: "United States",
    summary:
      "Sun Country Airlines is a U.S. low-cost carrier focused on leisure travel across North America and the Caribbean.",
  },
  {
    name: "JSX",
    code: "XE",
    slug: "jsx-xe",
    region: "United States",
    summary:
      "JSX is a premium public charter airline offering hassle-free, semi-private jet service between select U.S. cities with private terminal access and a streamlined travel experience.",
  },
  {
    name: "Allegiant Air",
    code: "G4",
    slug: "allegiant-air-g4",
    region: "United States",
    summary:
      "Allegiant Air is a U.S. ultra-low-cost airline connecting smaller cities with popular vacation destinations.",
  },
  {
    name: "Lufthansa",
    code: "LH",
    slug: "lufthansa-lh",
    region: "Germany",
    summary:
      "Lufthansa is Germany's flag carrier and one of Europe's largest airlines, serving destinations worldwide.",
  },
  {
    name: "British Airways",
    code: "BA",
    slug: "british-airways-ba",
    region: "United Kingdom",
    summary:
      "British Airways is the United Kingdom's flag carrier, operating a comprehensive global route network from London Heathrow.",
  },
  {
    name: "Swiss International Air Lines",
    code: "LX",
    slug: "swiss-international-air-lines-lx",
    region: "Switzerland",
    summary:
      "Swiss International Air Lines is Switzerland's flag carrier, providing premium service across Europe and long-haul destinations.",
  },
  {
    name: "Emirates",
    code: "EK",
    slug: "emirates-ek",
    region: "United Arab Emirates",
    summary:
      "Emirates is one of the world's leading international airlines, connecting passengers through its global hub in Dubai.",
  },
  {
    name: "Turkish Airlines",
    code: "TK",
    slug: "turkish-airlines-tk",
    region: "Turkey",
    summary:
      "Turkish Airlines flies to more countries than any other airline, connecting global destinations through Istanbul.",
  },
  {
    name: "Air Canada",
    code: "AC",
    slug: "air-canada-ac",
    region: "Canada",
    summary:
      "Air Canada is Canada's largest airline and flag carrier, serving an extensive domestic and international network across six continents.",
  },
  {
    name: "Air Europa",
    code: "UX",
    slug: "air-europa-ux",
    region: "Spain",
    summary:
      "Air Europa is a Spanish airline connecting Europe with the Americas, the Caribbean, and domestic destinations across Spain.",
  },
  {
    name: "Vueling",
    code: "VY",
    slug: "vueling-vy",
    region: "Spain",
    summary:
      "Vueling is one of Europe's leading low-cost airlines, operating an extensive network across Europe, North Africa, and the Middle East.",
  },
  {
    name: "Pegasus Airlines",
    code: "PC",
    slug: "pegasus-airlines-pc",
    region: "Turkey",
    summary:
      "Pegasus Airlines is Turkey's leading low-cost carrier, connecting Europe, the Middle East, Central Asia, and domestic Turkish destinations.",
  },
  {
    name: "Akasa Air",
    code: "QP",
    slug: "akasa-air-qp",
    region: "India",
    summary:
      "Akasa Air is a rapidly growing Indian airline offering affordable domestic and international flights with a modern Boeing 737 MAX fleet.",
  },
  {
    name: "Scoot",
    code: "TR",
    slug: "scoot-tr",
    region: "Singapore",
    summary:
      "Scoot is Singapore Airlines' low-cost subsidiary, operating routes across Asia, Australia, Europe, and the Middle East.",
  },
  {
    name: "ZIPAIR",
    code: "ZG",
    slug: "zipair-zg",
    region: "Japan",
    summary:
      "ZIPAIR is Japan Airlines' low-cost international airline, offering affordable long-haul flights from Tokyo to destinations across Asia and North America.",
  },
  {
    name: "Hawaiian Airlines",
    code: "HA",
    slug: "hawaiian-airlines-ha",
    region: "United States",
    summary:
      "Hawaiian Airlines is Hawaii's largest airline, connecting the Hawaiian Islands with the U.S. mainland, Asia, Oceania, and the South Pacific.",
  },
  {
    name: "Ryanair",
    code: "FR",
    slug: "ryanair-fr",
    region: "Ireland",
    summary:
      "Ryanair is Europe's largest low-cost airline, offering extensive point-to-point service across the continent.",
  },
  {
    name: "easyJet",
    code: "U2",
    slug: "easyjet-u2",
    region: "United Kingdom",
    summary:
      "easyJet is one of Europe's largest low-cost carriers, serving hundreds of routes across Europe and North Africa.",
  },
  {
    name: "Volaris Airlines",
    code: "Y4",
    slug: "volaris-airlines-y4",
    region: "Mexico",
    summary:
      "Volaris is a major low-cost carrier in Mexico with routes across Mexico, the United States, Central America, and South America.",
  },
  {
    name: "Viva Aerobus",
    code: "VB",
    slug: "viva-aerobus-vb",
    region: "Mexico",
    summary:
      "Viva Aerobus is a Mexican low-cost airline based in Monterrey, offering affordable domestic and international flights.",
  },
  {
    name: "Air China",
    code: "CA",
    slug: "air-china-ca",
    region: "China",
    summary:
      "Air China is China's flag carrier and a Star Alliance member with long-haul and domestic service from Beijing and Shanghai.",
  },
  {
    name: "United Airlines",
    code: "UA",
    slug: "united-airlines-ua",
    region: "United States",
    summary:
      "United Airlines operates one of the world's largest route networks, connecting North America with global destinations.",
  },
  {
    name: "China Southern Airlines",
    code: "CZ",
    slug: "china-southern-airlines-cz",
    region: "China",
    summary:
      "China Southern Airlines is one of China's largest carriers, serving extensive routes across Asia and beyond.",
  },
  {
    name: "Air India",
    code: "AI",
    slug: "air-india-ai",
    region: "India",
    summary:
      "Air India is India's flag carrier, connecting major Indian cities with Asia, Europe, North America, and the Middle East.",
  },
  {
    name: "China Eastern Airlines",
    code: "MU",
    slug: "china-eastern-airlines-mu",
    region: "China",
    summary:
      "China Eastern Airlines serves a broad domestic and international network from major Chinese hubs.",
  },
  {
    name: "Czech Airlines",
    code: "OK",
    slug: "czech-airlines-ok",
    region: "Czech Republic",
    summary:
      "Czech Airlines is one of Europe's older carriers, historically serving routes from Prague across Europe.",
  },
  {
    name: "South African Airways",
    code: "SA",
    slug: "south-african-airways-sa",
    region: "South Africa",
    summary:
      "South African Airways is South Africa's flag carrier, known for regional African and international services.",
  },
  {
    name: "El Al Israel Airlines",
    code: "LY",
    slug: "el-al-israel-airlines-ly",
    region: "Israel",
    summary:
      "El Al Israel Airlines connects Israel with destinations across Europe, North America, Africa, and Asia.",
  },
  {
    name: "Kenya Airways",
    code: "KQ",
    slug: "kenya-airways-kq",
    region: "Kenya",
    summary:
      "Kenya Airways is a leading African carrier based in Nairobi with strong connectivity across Africa and long-haul markets.",
  },
  {
    name: "Egyptair",
    code: "MS",
    slug: "egyptair-ms",
    region: "Egypt",
    summary:
      "Egyptair is Egypt's national airline, operating from Cairo to destinations in Africa, Europe, the Middle East, and Asia.",
  },
  {
    name: "Condor Airlines",
    code: "DE",
    slug: "condor-airlines-de",
    region: "Germany",
    summary:
      "Condor Airlines is a German leisure carrier offering holiday routes to Europe, the Americas, Africa, and beyond.",
  },
  {
    name: "Frontier Airlines",
    code: "F9",
    slug: "frontier-airlines-f9",
    region: "United States",
    summary:
      "Frontier Airlines is a U.S. ultra-low-cost carrier focused on affordable domestic and international travel.",
  },
  {
    name: "Piedmont Airlines",
    code: "PT",
    slug: "piedmont-airlines-pt",
    region: "United States",
    summary:
      "Piedmont Airlines is a regional carrier operating under the American Eagle brand.",
  },
  {
    name: "SkyWest Airlines",
    code: "OO",
    slug: "skywest-airlines-oo",
    region: "United States",
    summary:
      "SkyWest Airlines operates regional flights for major U.S. airline partners across North America.",
  },
  {
    name: "Air Wisconsin",
    code: "ZW",
    slug: "air-wisconsin-zw",
    region: "United States",
    summary:
      "Air Wisconsin is a regional U.S. carrier supporting scheduled service for major airline partners.",
  },
  {
    name: "Mesa Airlines",
    code: "YV",
    slug: "mesa-airlines-yv",
    region: "United States",
    summary:
      "Mesa Airlines is a regional carrier operating routes for major U.S. airline brands.",
  },
  {
    name: "Republic Airways",
    code: "YX",
    slug: "republic-airways-yx",
    region: "United States",
    summary:
      "Republic Airways is a U.S. regional airline operating flights for major network carriers.",
  },
  {
    name: "CommuteAir",
    code: "C5",
    slug: "commutair-c5",
    region: "United States",
    summary:
      "CommuteAir is a regional airline operating flights under the United Express brand.",
  },
  {
    name: "Endeavor Air",
    code: "9E",
    slug: "endeavor-air-9e",
    region: "United States",
    summary:
      "Endeavor Air is a Delta Connection regional carrier serving cities across North America.",
  },
  {
    name: "Xiamen Airlines",
    code: "MF",
    slug: "xiamen-airlines-mf",
    region: "China",
    summary:
      "Xiamen Airlines is a Chinese carrier known for domestic and international service from Fujian province.",
  },
  {
    name: "Horizon Air",
    code: "QX",
    slug: "horizon-air-qx",
    region: "United States",
    summary:
      "Horizon Air is an Alaska Air Group regional airline serving the Pacific Northwest and western U.S.",
  },
  {
    name: "Envoy Air",
    code: "MQ",
    slug: "envoy-air-mq",
    region: "United States",
    summary:
      "Envoy Air is an American Airlines Group regional carrier operating American Eagle flights.",
  },
  {
    name: "PSA Airlines",
    code: "OH",
    slug: "psa-airlines-oh",
    region: "United States",
    summary:
      "PSA Airlines is a regional airline operating as American Eagle from hubs across the United States.",
  },
  {
    name: "Porter Airlines",
    code: "PD",
    slug: "porter-airlines-pd",
    region: "Canada",
    summary:
      "Porter Airlines is a Canadian carrier known for efficient regional and transborder travel.",
  },
  {
    name: "Scandinavian Airlines",
    code: "SK",
    slug: "scandinavian-airlines-sk",
    region: "Scandinavia",
    summary:
      "Scandinavian Airlines connects Denmark, Norway, and Sweden with Europe, Asia, and North America.",
  },
  {
    name: "Aeroflot",
    code: "SU",
    slug: "aeroflot-su",
    region: "Russia",
    summary:
      "Aeroflot is a long-established carrier historically serving Russian domestic and international routes.",
  },
  {
    name: "Finnair",
    code: "AY",
    slug: "finnair-ay",
    region: "Finland",
    summary:
      "Finnair is Finland's flag carrier, known for Nordic design and Europe-Asia connectivity through Helsinki.",
  },
  {
    name: "Azul Airlines",
    code: "AD",
    slug: "azul-airlines-ad",
    region: "Brazil",
    summary:
      "Azul Airlines is a major Brazilian carrier serving an extensive network across Brazil and international destinations.",
  },
  {
    name: "Avianca",
    code: "AV",
    slug: "avianca-av",
    region: "Colombia",
    summary:
      "Avianca is one of Latin America's leading airlines, connecting the Americas with Europe and beyond.",
  },
  {
    name: "Korean Air",
    code: "KE",
    slug: "korean-air-ke",
    region: "South Korea",
    summary:
      "Korean Air is South Korea's flagship carrier with a broad international network from Seoul.",
  },
  {
    name: "Garuda Indonesia",
    code: "GA",
    slug: "garuda-indonesia-ga",
    region: "Indonesia",
    summary:
      "Garuda Indonesia is Indonesia's flag carrier, offering domestic and international service from Jakarta and other hubs.",
  },
  {
    name: "VietJet Air",
    code: "VJ",
    slug: "vietjet-air-vj",
    region: "Vietnam",
    summary:
      "VietJet Air is a Vietnamese low-cost carrier serving domestic and international routes across Asia.",
  },
  {
    name: "WestJet",
    code: "WS",
    slug: "westjet-ws",
    region: "Canada",
    summary:
      "WestJet is a Canadian airline serving North America, the Caribbean, Europe, and leisure destinations.",
  },
  {
    name: "Malta Air",
    code: "AL",
    slug: "malta-air-al",
    region: "Malta",
    summary:
      "Malta Air is a Malta-based airline operating as part of the Ryanair Group.",
  },
  {
    name: "Eurowings",
    code: "EW",
    slug: "eurowings-ew",
    region: "Germany",
    summary:
      "Eurowings is a German low-cost airline offering short and medium-haul flights across Europe and beyond.",
  },
  {
    name: "Norwegian Air",
    code: "DY",
    slug: "norwegian-air-dy",
    region: "Norway",
    summary:
      "Norwegian Air is a Scandinavian carrier known for affordable travel across Europe and selected international routes.",
  },
  {
    name: "Hong Kong Airlines",
    code: "HX",
    slug: "hong-kong-airlines-hx",
    region: "Hong Kong",
    summary:
      "Hong Kong Airlines connects Hong Kong with destinations across Asia and selected international markets.",
  },
  {
    name: "Royal Jordanian",
    code: "RJ",
    slug: "royal-jordanian-rj",
    region: "Jordan",
    summary:
      "Royal Jordanian is Jordan's flag carrier with routes across the Middle East, Europe, Asia, Africa, and North America.",
  },
  {
    name: "Royal Air Maroc",
    code: "AT",
    slug: "royal-air-maroc-at",
    region: "Morocco",
    summary:
      "Royal Air Maroc is Morocco's national carrier, based in Casablanca with strong Africa-Europe connectivity.",
  },
  {
    name: "Iberia",
    code: "IB",
    slug: "iberia-ib",
    region: "Spain",
    summary:
      "Iberia is Spain's national airline, connecting Madrid with Europe, the Americas, Africa, and the Middle East.",
  },
  {
    name: "Air New Zealand",
    code: "NZ",
    slug: "air-new-zealand-nz",
    region: "New Zealand",
    summary:
      "Air New Zealand is New Zealand's flag carrier with Pacific, Asia, North America, and domestic routes.",
  },
  {
    name: "Kuwait Airways",
    code: "KU",
    slug: "kuwait-airways-ku",
    region: "Kuwait",
    summary:
      "Kuwait Airways is Kuwait's national carrier, serving the Middle East, Asia, Europe, and North America.",
  },
  {
    name: "Qantas Airways",
    code: "QF",
    slug: "qantas-airways-qf",
    region: "Australia",
    summary:
      "Qantas Airways is Australia's flagship airline with extensive domestic and international service.",
  },
  {
    name: "Cathay Pacific",
    code: "CX",
    slug: "cathay-pacific-cx",
    region: "Hong Kong",
    summary:
      "Cathay Pacific is Hong Kong's flagship carrier serving Asia, North America, Europe, and Oceania.",
  },
  {
    name: "Oman Air",
    code: "WY",
    slug: "oman-air-wy",
    region: "Oman",
    summary:
      "Oman Air is the national airline of Oman, based in Muscat with routes across Asia, Africa, Europe, and the Middle East.",
  },
  {
    name: "Virgin Atlantic",
    code: "VS",
    slug: "virgin-atlantic-vs",
    region: "United Kingdom",
    summary:
      "Virgin Atlantic is a British long-haul carrier with major routes from London and Manchester.",
  },
  {
    name: "Brussels Airlines",
    code: "SN",
    slug: "brussels-airlines-sn",
    region: "Belgium",
    summary:
      "Brussels Airlines is Belgium's national airline and a Lufthansa Group member.",
  },
  {
    name: "Air France",
    code: "AF",
    slug: "air-france-af",
    region: "France",
    summary:
      "Air France is France's flag carrier, serving global destinations from Paris Charles de Gaulle.",
  },
  {
    name: "Japan Airlines",
    code: "JL",
    slug: "japan-airlines-jl",
    region: "Japan",
    summary:
      "Japan Airlines is one of Japan's leading international airlines with routes across Asia, North America, Europe, and Oceania.",
  },
  {
    name: "Etihad Airways",
    code: "EY",
    slug: "etihad-airways-ey",
    region: "United Arab Emirates",
    summary:
      "Etihad Airways is the national airline of the UAE, based in Abu Dhabi with premium global service.",
  },
  {
    name: "TAP Air Portugal",
    code: "TP",
    slug: "tap-air-portugal-tp",
    region: "Portugal",
    summary:
      "TAP Air Portugal is Portugal's national carrier with strong links between Europe, Africa, and the Americas.",
  },
  {
    name: "Austrian Airlines",
    code: "OS",
    slug: "austrian-airlines-os",
    region: "Austria",
    summary:
      "Austrian Airlines connects Vienna with Europe, Asia, and the Americas as part of the Lufthansa Group.",
  },
  {
    name: "Caribbean Airlines",
    code: "BW",
    slug: "caribbean-airlines-bw",
    region: "Trinidad and Tobago",
    summary:
      "Caribbean Airlines is a major Caribbean carrier serving North America, South America, and island routes.",
  },
  {
    name: "Ethiopian Airlines",
    code: "ET",
    slug: "ethiopian-airlines-et",
    region: "Ethiopia",
    summary:
      "Ethiopian Airlines is Africa's largest airline, connecting Addis Ababa with destinations on five continents.",
  },
  {
    name: "Philippine Airlines",
    code: "PR",
    slug: "philippine-airlines-pr",
    region: "Philippines",
    summary:
      "Philippine Airlines is the flag carrier of the Philippines, known for warm service across domestic and international routes.",
  },
  {
    name: "EVA Air",
    code: "BR",
    slug: "eva-air-br",
    region: "Taiwan",
    summary:
      "EVA Air is a Taiwanese international airline recognized for comfort, service, and global connectivity.",
  },
  {
    name: "Fiji Airways",
    code: "FJ",
    slug: "fiji-airways-fj",
    region: "Fiji",
    summary:
      "Fiji Airways is Fiji's national airline, linking the South Pacific with Asia, North America, Australia, and New Zealand.",
  },
  {
    name: "Thai Airways",
    code: "TG",
    slug: "thai-airways-tg",
    region: "Thailand",
    summary:
      "Thai Airways is Thailand's flag carrier, based at Bangkok Suvarnabhumi Airport.",
  },
  {
    name: "Aer Lingus",
    code: "EI",
    slug: "aer-lingus-ei",
    region: "Ireland",
    summary:
      "Aer Lingus is Ireland's flag carrier with a strong network between Europe and North America.",
  },
  {
    name: "Vietnam Airlines",
    code: "VN",
    slug: "vietnam-airlines-vn",
    region: "Vietnam",
    summary:
      "Vietnam Airlines is Vietnam's national carrier, serving domestic and international routes across Asia, Europe, and Australia.",
  },
  {
    name: "Aeromexico",
    code: "AM",
    slug: "aeromexico-am",
    region: "Mexico",
    summary:
      "Aeromexico is Mexico's flag carrier, based in Mexico City with service across the Americas, Europe, and Asia.",
  },
  {
    name: "Copa Airlines",
    code: "CM",
    slug: "copa-airlines-cm",
    region: "Panama",
    summary:
      "Copa Airlines is Panama's full-service carrier, connecting the Americas through Panama City.",
  },
  {
    name: "SriLankan Airlines",
    code: "UL",
    slug: "srilankan-airlines-ul",
    region: "Sri Lanka",
    summary:
      "SriLankan Airlines is Sri Lanka's flag carrier, known for hospitality and regional connectivity.",
  },
  {
    name: "Asiana Airlines",
    code: "OZ",
    slug: "asiana-airlines-oz",
    region: "South Korea",
    summary:
      "Asiana Airlines is a South Korean carrier serving Asia, North America, Australia, and Europe.",
  },
  {
    name: "LATAM Airlines",
    code: "LA",
    slug: "latam-airlines-la",
    region: "Latin America",
    summary:
      "LATAM Airlines is a major Latin American airline group with routes across South America, North America, Europe, and Oceania.",
  },
  {
    name: "Singapore Airlines",
    code: "SQ",
    slug: "singapore-airlines-sq",
    region: "Singapore",
    summary:
      "Singapore Airlines is a premium global carrier based in Singapore with extensive long-haul connectivity.",
  },
  {
    name: "Norse Atlantic Airways",
    code: "N0",
    slug: "norse-atlantic-airways-n0",
    region: "Norway",
    summary:
      "Norse Atlantic Airways is a Norwegian long-haul airline operating Boeing 787 routes across the Atlantic.",
  },
  {
    name: "Icelandair",
    code: "FI",
    slug: "icelandair-fi",
    region: "Iceland",
    summary:
      "Icelandair is Iceland's flag carrier, connecting Europe and North America through Reykjavik.",
  },
];

export const findAirlineBySlug = (slug) =>
  airlines.find((airline) => airline.slug === slug);
